import PrimeVue from "primevue/config";
import Tooltip from "primevue/tooltip";
import OverlayPanel from "primevue/overlaypanel";
import Skeleton from "primevue/skeleton";
import Calendar from "primevue/calendar";
import Dialog from "primevue/dialog";
import InputSwitch from "primevue/inputswitch";

export function initPrimeVue( { app, } ) {
	app.component( "Calendar", Calendar );
	app.component( "Dialog", Dialog );
	app.component( "InputSwitch", InputSwitch );
	app.component( "OverlayPanel", OverlayPanel );
	app.component( "Skeleton", Skeleton );
	app.directive( "tooltip", Tooltip );
	app.use( PrimeVue );
}
